import { render, staticRenderFns } from "./KELabel.vue?vue&type=template&id=09e832a0&scoped=true&"
import script from "./KELabel.vue?vue&type=script&lang=ts&"
export * from "./KELabel.vue?vue&type=script&lang=ts&"
import style0 from "./KELabel.vue?vue&type=style&index=0&id=09e832a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e832a0",
  null
  
)

export default component.exports